import React from 'react';
import Picture from 'src/components/Common/Picture';
import classNames from 'classnames';

import * as styles from './Testimonial.module.css';

interface TestimonialProps {
  /** Text of the Testimonial. */
  children: React.ReactNode[];
  /** CSS class name */
  className?: string;
  /** Headline for the testimonial. */
  header?: React.ReactNode;
  /** Imported picture. */
  image?: string;
  /** Path to picture. */
  picture?: string;
}

const Testimonial = ({
  children,
  className,
  header,
  image,
  picture,
}: TestimonialProps) => {
  const processedChildren = children.map((child, index) => {
    return typeof child === 'string' ? (
      // eslint-disable-next-line react/no-array-index-key
      <p key={`index_${index}`}>{child}</p>
    ) : (
      child
    );
  });
  return (
    <div className={classNames(className, 'ce', styles.ceTestimonial)}>
      {header}
      {picture && (
        <Picture
          src={`testimonials/${picture}`}
          alt="Bild Kundenstimme"
          circle
        />
      )}
      {!picture && image && (
        <Picture image={image} alt="Bild Kundenstimme" circle />
      )}
      {processedChildren}
    </div>
  );
};

Testimonial.defaultProps = {
  className: null,
  header: null,
  image: null,
  picture: null,
};

export default Testimonial;
